export var DISCLOSURE_TYPES = {
  SERVICE_CONTRACT: 'SERVICE_CONTRACT',
  SURFACE_PROTECTION: 'SURFACE_PROTECTION',
  DEBT_CANCELLATION_AGGREEMENT: 'DEBT_CANCELLATION_AGGREEMENT',
  CONTRACT_CANCELLATION_OPTION: 'CONTRACT_CANCELLATION_OPTION',
  INSURANCE: 'INSURANCE',
  THEFT_DETERRENT: 'THEFT_DETERRENT',
  LIFE_AND_HEALTH_INSURANCE: 'LIFE_AND_HEALTH_INSURANCE',
  ACCIDENTAL_HEALTH_INSURANCE: 'ACCIDENTAL_HEALTH_INSURANCE',
  OTHER: 'OTHER',
  MAINTENANCE: 'MAINTENANCE',
  NONE: 'NONE',
  ETCHING: 'ETCHING',
  EXCESS_WEAR_USER_PROTECTION: 'EXCESS_WEAR_USER_PROTECTION',
  TIRENWHEEL_PROTECTION_PRODUCT: 'TIRENWHEEL_PROTECTION_PRODUCT',
  WARRANTY: 'WARRANTY',
  TINT_OR_PINSTRIPE: 'TINT_OR_PINSTRIPE',
  PAINTLESS_DENT_REPAIR: 'PAINTLESS_DENT_REPAIR',
  ROAD_AND_HAZARD: 'ROAD_AND_HAZARD',
  SERVICE_PLAN: 'SERVICE_PLAN',
  THEFT_RECOVERY: 'THEFT_RECOVERY',
  ACCIDENTAL_LIFE_HEALTH_INSURANCE: 'ACCIDENTAL_LIFE_HEALTH_INSURANCE',
  BUNDLED_PRODUCT: 'BUNDLED_PRODUCT',
  DIMINISHED_ASSET_PROTECTION: 'DIMINISHED_ASSET_PROTECTION'
};
export var PRODUCTS = {
  LIFE_AND_HEALTH_INSURANCE: 'LIFE_AND_HEALTH_INSURANCE',
  ACCIDENTAL_HEALTH_INSURANCE: 'ACCIDENTAL_HEALTH_INSURANCE',
  ACCIDENTAL_LIFE_HEALTH_INSURANCE: 'ACCIDENTAL_LIFE_HEALTH_INSURANCE',
  INSURANCE: 'INSURANCE'
};
export var CREDIT_LIFE_INSURANCE_DISCLOSURE_TYPES = [DISCLOSURE_TYPES.LIFE_AND_HEALTH_INSURANCE, DISCLOSURE_TYPES.ACCIDENTAL_HEALTH_INSURANCE, DISCLOSURE_TYPES.ACCIDENTAL_LIFE_HEALTH_INSURANCE];
export var CREDIT_LIFE_INSURANCE_PRODUCTS = [PRODUCTS.LIFE_AND_HEALTH_INSURANCE, PRODUCTS.ACCIDENTAL_HEALTH_INSURANCE, PRODUCTS.ACCIDENTAL_LIFE_HEALTH_INSURANCE];